<template>
    <div class="form-group">
        <div v-if="!showEdit">
            <label :for="'routineDropdown' + index">{{ _t("Routine") }}</label>
            <select :disabled="true" v-model="selectedRoutineId" class="form-control"
                    :id="'routineDropdown' + index">
                <option value="" selected>{{ _t("Select...") }}</option>
                <option v-for="(routineLabel, routineId) in routineOptions" :key="routineId"
                        :value="routineId">{{ routineLabel }}
                </option>
            </select>
            <button :disabled="isSurveyActive" style="margin-top: 12px" class="btn btn-warning" @click="showEdit = true"> {{ _t('Edit') }}</button>
        </div>

        <div v-else>
            <label :for="'routineDropdown' + index">{{ _t("Routine") }}</label>
            <select v-model="selectedRoutineId" class="form-control"
                    :id="'routineDropdown' + index">
                <option disabled value="" selected>{{ _t("Select...") }}</option>
                <option v-for="(routineLabel, routineId) in routineOptions" :key="routineId"
                        :value="routineId">{{ routineLabel }}
                </option>
            </select>
            <button style="margin-top: 12px"  class="btn btn-success" @click="handleEdit"> {{ _t('Save') }}</button>
            <button style="margin-top: 12px"  class="btn btn-secondary" @click="cancelEdit"> {{ _t('Cancel') }}</button>
        </div>

    </div>
</template>

<script>
import Swal from "sweetalert2";

export default {

    name: "ShowRule",
    props: [
        'routineOptions',
        'index',
        'ruleId',
        'routineId',
        'surveyId',
        'isSurveyActive'
    ],

    data() {
        return {
            showEdit: false,
            selectedRoutineId: this.routineId
        }
    },
    methods: {
        handleEdit() {
            this.handleRuleUpdated(this.selectedRoutineId, this.ruleId)
        },

        cancelEdit() {
            this.showEdit = false;
            this.selectedRoutineId = this.routineId
        },
        handleRuleUpdated(routineId, ruleId) {

            axios.put(`/survey/${this.surveyId}/rules/${ruleId}`, {routine_id: routineId})
                .then((res) => {
                    this.$emit('rule-updated')
                    this.showEdit = false;
                    Swal.fire({
                        text: _t("Rule updated successfully!"),
                        icon: "success",
                        duration: '1000'
                    })
                })
                .catch((err) => {
                    this.selectedRoutineId = this.routineId
                    Swal.fire({
                        text: err.response.data.message || 'Something went wrong',
                        icon: "error",
                        duration: '1000'
                    })
                });

        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/js/app/components/ShowRule.vue